export default "__VITE_ASSET__Oa1DLKCj__"